import Vue from 'vue'
import Vuex from 'vuex'
import profile from './profile'
Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    routeKey: 1,
    immoSupport: require('./immoSupport').default,
    diagSupport: require('./diagSupport').default,
    ...profile
  },
  mutations: {
    routeReload(state) {
      state.routeKey++;
    },
  },
  getters: {

  },
  actions: {
  },
  modules: {
  }
})
